import React from "react";
import { useIntl } from "react-intl";
import { PeekBox, PeekDialog, PeekDialogContent } from "@piiqtechnologies/ui-components";
import messages from "../messages.i18n";
const STORYLANE_DEMO_URL = process.env.PEEK_APP_STORYLANE_DEMO_URL;
const FRAME_WIDTH = "min(90vw, 1900px, calc((100vh - 235px) * 16 / 9))";
const FRAME_HEIGHT = "min(calc(90vw * 9 / 16 + 25px), 1094px, calc(100vh - 210px))";
export const StorylaneTourDialog = ({ open, onClose }) => {
    const intl = useIntl();
    const title = intl.formatMessage(messages.aiDiscoverabilityDashboardTourDialogTitle);
    return (React.createElement(PeekDialog, { open: open, onClose: onClose, maxWidth: false, hasCloseIcon: true, title: title, PaperProps: { sx: { m: 2, maxWidth: "none" } } },
        React.createElement(PeekDialogContent, { sx: { p: 3, display: "flex", alignItems: "center", justifyContent: "center" } }, open && STORYLANE_DEMO_URL && (React.createElement(PeekBox, { sx: {
                width: FRAME_WIDTH,
                height: FRAME_HEIGHT,
                flexShrink: 0,
                overflow: "hidden",
                borderRadius: 8,
            } },
            React.createElement("iframe", { loading: "lazy", src: STORYLANE_DEMO_URL, title: title, allow: "fullscreen", style: {
                    display: "block",
                    width: "calc(100% + 2px)",
                    height: "calc(100% + 2px)",
                    marginLeft: "-1px",
                    marginTop: "-1px",
                    border: 0,
                } }))))));
};
export default StorylaneTourDialog;
